/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/react';

import { Grid, Hidden, PageGridContainer, Skeleton, breakpoints } from '@coursera/cds-core';

const placeholderShimmer = keyframes`
  0% {
    background-position: -500px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const styles = {
  moduleContainer: css`
    width: 100%;
    padding: var(--cds-spacing-600);
    border: 1px solid var(--cds-color-grey-50);
    border-radius: calc(var(--cds-border-radius-200) + var(--cds-border-radius-50));

    ${breakpoints.down('sm')} {
      border: none;
      padding: 0;
    }
  `,
  placeholderWrapper: css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-200);
    justify-content: center;
  `,
  imagePlaceholderWrapper: css`
    display: flex;
    justify-content: end;

    ${breakpoints.down('sm')} {
      justify-content: left;
    }
  `,
  image: css`
    height: 300px !important;

    ${breakpoints.down('sm')} {
      margin-top: var(--cds-spacing-400);
      height: 200px !important;
    }
  `,
  title: css`
    margin-bottom: var(--cds-spacing-200);
  `,
  animated: css`
    background-color: var(--cds-color-neutral-disabled-weak);
    background: linear-gradient(
      to right,
      var(--cds-color-neutral-disabled-weak) 10%,
      var(--cds-color-neutral-disabled) 40%,
      var(--cds-color-neutral-disabled-weak) 60%
    );
    animation: ${placeholderShimmer} 4s linear 0s infinite normal forwards;
  `,
};

const PathwaysCareerOutcomesPlaceholder = () => {
  return (
    <PageGridContainer>
      <Grid item xs={12}>
        <div css={styles.moduleContainer}>
          <Grid container>
            <Grid item xs={12} md={6} css={styles.placeholderWrapper}>
              <Hidden smDown>
                <Skeleton variant="rect" width="60%" height={72} css={[styles.title, styles.animated]} />
              </Hidden>
              <Hidden mdUp>
                <Skeleton variant="rect" width="60%" height={48} css={[styles.title, styles.animated]} />
              </Hidden>
              <Skeleton className="placeholder2" variant="rect" width="80%" height={20} css={styles.animated} />
              <Skeleton className="placeholder3" variant="rect" width="85%" height={20} css={styles.animated} />
              <Skeleton className="placeholder3" variant="rect" width="70%" height={20} css={styles.animated} />
              <Skeleton className="placeholder3" variant="rect" width="65%" height={20} css={styles.animated} />
            </Grid>
            <Grid item xs={12} md={6} css={styles.imagePlaceholderWrapper}>
              <Skeleton variant="rect" width="60%" css={[styles.image, styles.animated]} />
            </Grid>
          </Grid>
        </div>
      </Grid>
    </PageGridContainer>
  );
};

export default PathwaysCareerOutcomesPlaceholder;
